// GET_CONVERSATIONS
export const GET_CONVERSATIONS = "GET_CONVERSATIONS";

// GET_CONVERSATION_DETAILS
export const GET_CONVERSATION_DETAILS = "GET_CONVERSATION_DETAILS";

// BLOCK_UNBLOCK_CONVERSATION
export const BLOCK_UNBLOCK_CONVERSATION = "BLOCK_UNBLOCK_CONVERSATION";

// DELETE_MESSAGE
export const DELETE_MESSAGE = "DELETE_MESSAGE";

// GET_CHAT_STATS
export const GET_CHAT_STATS = "GET_CHAT_STATS";

// CLEAR_CONVERSATION_DETAILS
export const CLEAR_CONVERSATION_DETAILS = "CLEAR_CONVERSATION_DETAILS";
